import { ArenaOpsMovementRowSchema } from "./arena-ops-filters.dto";
import { z } from "zod";

/** Per-user drill-down. Keyset on `id DESC`; page 1 opens at `:after = 2147483647`. */
export const ArenaOpsUsersMovementsResponseSchema = z.object({
  hubUserId: z.number().int(),
  rows: z.array(ArenaOpsMovementRowSchema),
  nextCursor: z.string().nullable(),
});
export type ArenaOpsUsersMovementsResponse = z.infer<typeof ArenaOpsUsersMovementsResponseSchema>;
